export const ORGANIZATIONSECTION_LOADING = 'REDUX_SAGA_ORGANIZATIONSECTION_LOADING';
export const GET_ORGANIZATIONSECTION_DATA_SUCCESS = 'REDUX_SAGA_GET_ORGANIZATIONSECTION_DATA_SUCCESS';
export const GET_ORGANIZATIONSECTION_DATA_ERROR = 'REDUX_SAGA_GET_ORGANIZATIONSECTION_DATA_ERROR';
export const ORGANIZATIONSECTION_END_LOADING = 'REDUX_SAGA_ORGANIZATIONSECTION_END_LOADING';
export const RESET_ORGANIZATIONSECTION = 'REDUX_SAGA_RESET_ORGANIZATIONSECTION';

export const actionGetOrganizationSection = (dispatch, costRateList) => {
    dispatch({ type: ORGANIZATIONSECTION_LOADING, payload: { costRateList } })
};

export const actionResetOrganizationSection = (dispatch) => {
    dispatch({ type: RESET_ORGANIZATIONSECTION })
}

